import Constants from '../config/const';

export const togglePin = () => ({
  type: Constants.pin.toggle
});
